import JobLayout from 'components/JobLayout';
import ApplyHeader from 'pages/StartApplication/components/ApplyHeader';
import ApplyProvider from 'pages/StartApplication/components/ApplyProvider';
import { AddressDetails } from '@kanda-libs/ks-apply';
import { FunctionComponent } from 'react';

const Address: FunctionComponent = function () {
  return (
    <ApplyProvider>
      <JobLayout header={<ApplyHeader />} showJobCard={false}>
        <AddressDetails />
      </JobLayout>
    </ApplyProvider>
  );
};

export default Address;
